import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

export default function CarrierNetworkDetail({ networkStatusDetails, statusIds }) {
  return (
    <>
      {networkStatusDetails.pipelineStatus === statusIds.open && networkStatusDetails.coolDownDays > 0 &&
        <Box sx={{ display: "flex", justifyContent: "end" }}>
          <Typography variant="body1" color="black_opacity.100">
            Available in
          </Typography>
          <Typography variant="body1" color="black_opacity.100" sx={{ marginLeft: "3px" }}>
            {networkStatusDetails.coolDownDays}
          </Typography>
          <Typography variant="body1" color="black_opacity.100" sx={{ marginLeft: "3px" }}>
            days
          </Typography>
        </Box>
      }
      {networkStatusDetails.pipelineStatus === statusIds.open && networkStatusDetails.maxLeads &&
        <Box sx={{ display: "flex", justifyContent: "end" }}>
          <Typography variant="body1" color="black_opacity.100">
            Already at max number of leads
          </Typography>
        </Box>
      }
      {networkStatusDetails.pipelineStatus === statusIds.lead &&
        <>
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            <Typography variant="body1" color="black_opacity.100">
              Expires for inactivity:
            </Typography>
            <Typography variant="body1" color="black_opacity.100" sx={{ marginLeft: "3px" }}>
              {networkStatusDetails.activityExpireDays}
            </Typography>
            <Typography variant="body1" color="black_opacity.100" sx={{ marginLeft: "3px" }}>
              days
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            <Typography variant="body1" color="black_opacity.100">
              {`${networkStatusDetails.loadsMoved}/${networkStatusDetails.loadsRequired}`}
            </Typography>
            <Typography variant="body1" color="black_opacity.100" sx={{ marginLeft: "3px" }}>
              loads:
            </Typography>
            <Typography variant="body1" color="black_opacity.100" sx={{ marginLeft: "3px" }}>
              {networkStatusDetails.loadsExpireDays}
            </Typography>
            <Typography variant="body1" color="black_opacity.100" sx={{ marginLeft: "3px" }}>
              days
            </Typography>
          </Box>
        </>
      }
      {networkStatusDetails.pipelineStatus === statusIds.relationship &&
        <Box sx={{ display: "flex", justifyContent: "end" }}>
          <Typography variant="body1" color="black_opacity.100">
            {`${networkStatusDetails.loadsMoved}/${networkStatusDetails.loadsRequired}`}
          </Typography>
          <Typography variant="body1" color="black_opacity.100" sx={{ marginLeft: "3px" }}>
            loads:
          </Typography>
          <Typography variant="body1" color="black_opacity.100" sx={{ marginLeft: "3px" }}>
            {networkStatusDetails.loadsExpireDays}
          </Typography>
          <Typography variant="body1" color="black_opacity.100" sx={{ marginLeft: "3px" }}>
            days
          </Typography>
        </Box>
      }
    </>
  );
}

CarrierNetworkDetail.propTypes = {
  networkStatusDetails: PropTypes.object.isRequired,
  statusIds: PropTypes.object.isRequired
};
